<template>
  <div class="justify-center row message-chip">
    <q-chip
      v-model="infoDisp"
      square
      :class="
        infoLevel === ERROR_LEVEL.ERROR
          ? 'bg-negative'
          : infoLevel === ERROR_LEVEL.WARNING
          ? 'bg-warning'
          : 'bg-info'
      "
      text-color="white"
      icon="mdi-alert-circle"
      size="15px"
    >
      {{ infoMessage }}
    </q-chip>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';

interface Props {
  display: boolean | false;
  level: string;
  message: string;
}
const props = defineProps<Props>();

const infoDisp = ref(computed(() => props.display));
const infoMessage = ref(computed(() => props.message));
const infoLevel = ref(computed(() => props.level));

const ERROR_LEVEL = {
  INFORMATION: 'I',
  WARNING: 'W',
  ERROR: 'E',
};
</script>
<style>
.message-chip {
  min-height: 45px;
  margin-top: -30px;
}

.mst-mainte .message-chip {
  margin-top: -20px;
}

.mst-mainte .message-chip .q-chip {
  margin-bottom: 0;
  margin-top: 8px;
}

.message-chip .q-chip {
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

.message-chip .q-chip__content {
  white-space: break-spaces;
}
</style>
